import { AppDispatch, RootState } from '../store';
import { fetchCustomers } from './customerActions';
import { invalidateCustomersCache } from '../slices/customerSlice';

export const forceRefreshCustomers = () => async (dispatch: AppDispatch) => {
  try {
    console.log('Force refreshing customers data...');
    dispatch(invalidateCustomersCache());
    await dispatch(fetchCustomers({ page: 1, limit: 500 })).unwrap();
    console.log('Customers data force refreshed successfully');
    return true;
  } catch (error) {
    console.error('Failed to force refresh customers data:', error);
    return false;
  }
};
